import type { SearchDriversParams } from './driver.api';

export const driverKeys = {
  all: ['drivers'] as const,
  list: (params: SearchDriversParams): readonly unknown[] => [...driverKeys.lists(), params] as const,
  lists: (): readonly string[] => [...driverKeys.all, 'list'] as const,
};
